import * as React from 'react';

import cx from 'classnames';

import {
  ContactFormState,
  useContactPage,
} from 'hooks/page/contact/useContactPage';

import s from './ClassicContact.module.css';

export const ClassicContact = () => {
  const { formTitle, formState, onSubmit, renderFormElements } = useContactPage(
    {
      styles: {
        textarea: s.formTextArea,
        button: s.sendButton,
        error: s.error,
        subtitle: s.formSubTitle,
        recaptchaDisclaimer: s.recaptchaDisclaimer,
      },
    },
  );

  const ContactFormSent = () => (
    <div>
      <div className={cx(s.formTitle, s.bigTitle)}>
        Your message has been sent!
      </div>
    </div>
  );

  const ContactFormError = () => (
    <div className={cx(s.formTitle, s.bigTitle)}>
      Error sending your message. Please try again later.
    </div>
  );

  const renderForm = () => {
    switch (formState) {
      case ContactFormState.SENT:
        return <ContactFormSent />;
      case ContactFormState.ERROR:
        return <ContactFormError />;
      default:
        return (
          <>
            <h2 className={s.formTitle}>{formTitle}</h2>
            <form
              onSubmit={onSubmit}
              className={s.form}
              action="javascript:void(0)"
              method="POST"
              noValidate
            >
              {renderFormElements()}
            </form>
          </>
        );
    }
  };

  return <div className={s.root}>{renderForm()}</div>;
};
